<template>
  <section class="cockpit-panel realtime-panel">
    <div class="cockpit-title">实时监测数据</div>
    <div class="data-grid">
      <div v-for="item in dataItems" :key="item.label" class="data-item">
        <span class="data-icon"><img src="../../assets/img/jc.png"/></span>
        <div class="data-content">
          <p>{{ item.label }}</p>
          <strong>{{ item.value }}</strong>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const dataItems = [
  { icon: "△", label: "土壤温度", value: "25.3°C" },
  { icon: "◔", label: "土壤湿度", value: "56%" },
  { icon: "☼", label: "光照", value: "38600lux" },
  { icon: "◖", label: "EC值", value: "1.7mS/cm" },
  { icon: "◎", label: "pH值", value: "6.8" },
  { icon: "★", label: "氮含量", value: "82mg/kg" },
  { icon: "★", label: "磷含量", value: "46mg/kg" },
  { icon: "⊙", label: "钾含量", value: "118mg/kg" },
];
</script>

<style lang="less" scoped>
@import "./rightPanelShared.less";

.realtime-panel {
  padding: 78px 34px 30px;
}

.data-grid {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-auto-rows: 1fr;
  gap: 17px 26px;
  margin-top: 40px;
}

.data-item {
  min-width: 0;
  display: grid;
  grid-template-columns: 70px minmax(0, 1fr);
  grid-template-rows: 24px 34px;
  column-gap: 12px;
  align-items: center;
  text-align: left;
}

.data-icon {
  grid-row: 1 / 3;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6ffff2;
  font-size: 19px;
  font-weight: 900;
  border: 2px solid rgba(78, 255, 239, 0.78);
  border-radius: 50%;
  box-shadow: inset 0 0 14px rgba(78, 255, 239, 0.18), 0 0 10px rgba(78, 255, 239, 0.3);
  img{
    width: 30px;
    height: 30px;
  }
}
.data-content{
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}
.data-item p,
.data-item strong {
  margin: 0;
  color: #ffffff;
  font-weight: bold;
}

.data-item p {
  color: #7ffff5;
  font-size: 26px;
  line-height: 24px;
}

.data-item strong {
  font-size: 26px;
  line-height: 32px;
  white-space: nowrap;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.25);
}
</style>
